export default __webpack_public_path__ + "static/media/upi-logo.44da8710.png";